import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import shortid from 'shortid';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { translate } from 'react-i18next';
import getRoles from 'constants/roles';
import SidebarLink from './SidebarLink';
import SidebarCategory from './SidebarCategory';
import { AppStatusProps, DataListProps } from '../../../shared/prop-types/ReducerProps';
import { setRouterBlockNotif } from '../../../redux/actions/appActions';

class SidebarContent extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    onClick: PropTypes.func.isRequired,
    appStatus: AppStatusProps.isRequired,
    dataListStore: DataListProps.isRequired,
    t: PropTypes.func.isRequired,
  };

  hideSidebar = toRoute => {
    if (toRoute === '/dokumenti/potek') {
      localStorage.setItem('docAlertOverrride', true);
      this.forceUpdate();
    }
    const {
      appStatus: { blockRouter, showRouterBlockNotif },
      dispatch,
    } = this.props;

    if (blockRouter && !showRouterBlockNotif) {
      dispatch(setRouterBlockNotif(toRoute));
    }

    this.props.onClick();
  };

  render() {
    const {
      appStatus: { blockRouter },
      t,
      dataListStore: { showAlert },
    } = this.props;
    const { pathname } = window.location;
    const alertOverride = localStorage.getItem('docAlertOverrride');

    let showDocAlert = showAlert;
    if (alertOverride === 'true') {
      showDocAlert = false;
    }

    const roles = getRoles();

    const blockpath = blockRouter ? pathname : null;

    // const route = this.rf ? window.location.pathname

    return (
      <div className="sidebar__content">
        <ul key={shortid.generate()} className="sidebar__block">
          {(roles.full || roles.companies) && (
            <SidebarLink title="Ekipe" icon="briefcase" route="/ekipe" block={blockpath} onClick={this.hideSidebar} />
          )}
          {(roles.full || roles.workers === true || roles.workers.list) && (
            <SidebarLink title="Igralci" route="/igralci" icon="user" block={blockpath} onClick={this.hideSidebar} />
          )}
        </ul>
      </div>
    );
  }
}

const wr = withRouter(
  connect(state => ({
    dataListStore: state.dataList,
    appStatus: state.appStatus,
  }))(SidebarContent),
);

export default translate('common')(wr);
